export default __webpack_public_path__ + "static/video-thumbnail-b6ac09d18b1a65b83c6dbf713719e317.png";